var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vue-app-1"}},[(_vm.selectedTable === 'NeighborhoodResources')?_c('NeighborhoodResources'):_vm._e(),(_vm.selectedTable === 'NAC')?_c('NACTable'):_vm._e(),(_vm.selectedTable === 'NEC')?_c('NECTable'):_vm._e(),(_vm.selectedTable === 'HCA')?_c('HCATable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }